export default __webpack_public_path__ + "assets/ico_bankid-a6087869.svg";